export default __webpack_public_path__ + "static/media/trafficwise.0edb10ba.jpg";